import { ReportingComponentRegistry } from '../components/customization/component_registry'

const ALLOWED_COMPONENT_KEYS = Object.keys(ReportingComponentRegistry)

const filterComponentKeys = (componentKeys) => {
  if (!componentKeys || !Array.isArray(componentKeys)) {
    return ALLOWED_COMPONENT_KEYS
  }

  return componentKeys.filter((it) => ALLOWED_COMPONENT_KEYS.includes(it))
}

export const useDefaultConfiguration = (componentKeys) => {
  const filteredComponentKeys = filterComponentKeys(componentKeys)

  const allComponentsPresentConfiguration = filteredComponentKeys.reduce((acc, key) => ({
    ...acc,
    [key]: { presence: true }
  }), {})

  // exclude latestOccurredMeetings from components displayed by default
  return {
    ...allComponentsPresentConfiguration,
    latestOccurredMeetings: {
      presence: false
    }
  }
}
